// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"ListCard_listContainer__2mAax","spaceLabelCourse":"ListCard_spaceLabelCourse__28TLi","titleCard":"ListCard_titleCard__21PZr"};